import { dateFormatter } from 'core/utils';
import { defaultTemplate }from 'core/hoc';

function Date({ format, value, timeZone }) {
    return dateFormatter.format(value, format, timeZone);
}

export default defaultTemplate(Date);
